import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import UserLayout from './components/Layout/UserLayout';
import Home from './pages/Home';
import { Toaster } from "sonner";
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import About from './pages/About';
import Brands from './pages/Brands';
import Return from './pages/Return';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import Shipping from './pages/Shipping';
import ReturnPolicy from './pages/ReturnPolicy';
import CancellationAndReturnPolicy from './pages/CancellationAndReturnPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import VeshheonPrivacyPolicy from './pages/VeshheonPrivacyPolicy';
import ProductDetails from './components/Products/ProductDetails';
import CollectionPage from './pages/CollectionPage';
import Checkout from './components/Cart/Checkout';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import CancellationModal from './pages/CancellationModal';
import OrderDetailsPage from './pages/OrderDetailsPage';
import MyOrdersPage from './pages/MyOrdersPage';
import AdminLayout from './components/Admin/AdminLayout';
import AdminHomePage from './pages/AdminHome';
import UserManagement from './pages/UserManagement';
import ProductManagement from './components/Admin/ProductManagement';
import EditProductPage from './components/Admin/EditProductPage';
import OrderManagement from './components/Admin/OrderManagement';
import AdminReturnsPage from './components/Admin/AdminReturnsPage';
import Snowfall from "react-snowfall";

import {Provider} from "react-redux";
import store from "../redux/store";
import ProtectedRoute from './components/Common/ProtectedRoute';
import ScrollToTop from './components/Common/ScrollToTop';

import VendorRegistration from './pages/VendorRegistration';
import VendorDashboard from './pages/VendorDashboard';
import VendorProducts from './pages/VendorProducts';
import VendorOrders from './pages/VendorOrders';
import VendorPayouts from './pages/VendorPayouts';
import AdminVendors from './pages/AdminVendors';
import VendorProductNew from './pages/VendorProductNew';
import AdminVendorDetail from './pages/AdminVendorDetail';


const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        {/* Scroll to top on route change */}
        <ScrollToTop />

        <Toaster position="top-right" reverseOrder={false} />
        
        <Routes>
          <Route path="/" element={<UserLayout />}>
            {/* User Layout */}
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route path="profile" element={<Profile />} />
            <Route path="product/:id" element={<ProductDetails />} />
            <Route path="collections/:collection" element={<CollectionPage />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="order-confirmation" element={<OrderConfirmationPage />} />
            <Route path="CancellationModal" element={<CancellationModal />} />  
            <Route path="order/:id" element={<OrderDetailsPage />} />
            <Route path="order/:orderId/my-orders" element={<MyOrdersPage />} />
            <Route path="my-orders" element={<MyOrdersPage />} />
            <Route path="about" element={<About />} />
            <Route path="brands" element={<Brands />} />
            <Route path="return" element={<Return />} />
            <Route path="returnpolicy" element={<ReturnPolicy />} />
            <Route path="cancellationandreturnpolicy" element={<CancellationAndReturnPolicy />} />
            <Route path="privacypolicy" element={<PrivacyPolicy />} />
            <Route path="VeshheonPrivacyPolicy" element={<VeshheonPrivacyPolicy />} />
            <Route path="terms" element={<Terms />} />
            <Route path="contact" element={<Contact />} />
            <Route path="shipping" element={<Shipping />} />

            {/* Vendor Routes - Now inside UserLayout for navbar/footer */}
            <Route path="vendor/dashboard" element={
              <ProtectedRoute role="vendor">
                <VendorDashboard /> 
              </ProtectedRoute>
            } />
            
            <Route path="vendor/products" element={
              <ProtectedRoute role="vendor">
                <VendorProducts /> 
              </ProtectedRoute>
            } />
            
            <Route path="vendor/products/new" element={
              <ProtectedRoute role="vendor">
                <VendorProductNew /> 
              </ProtectedRoute>
            } />
            
            <Route path="vendor/orders" element={
              <ProtectedRoute role="vendor">
                <VendorOrders /> 
              </ProtectedRoute>
            } />
            
            <Route path="vendor/payouts" element={
              <ProtectedRoute role="vendor">
                <VendorPayouts /> 
              </ProtectedRoute>
            } />
          </Route>

          {/* Vendor Registration - Outside UserLayout (clean page) */}
          <Route path="/vendor/register" element={<VendorRegistration />} />

          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute role="admin">
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminHomePage />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="products" element={<ProductManagement />} />
            <Route path="products/:id/edit" element={<EditProductPage />} /> 
            <Route path="orders" element={<OrderManagement />} />
            <Route path="returns" element={<AdminReturnsPage />} />
            <Route path="vendors" element={<AdminVendors />} />
            <Route path="vendors/:vendorId" element={<AdminVendorDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  )
}

export default App;
